import { RootState } from 'store';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { boxShadow, maxWidth, primaryActiveColor, primaryColor, primaryFont, primaryHeadingColor, retina, secondaryFont, wMBold, wMedium } from 'constants/utilsStyles';
import styled from 'styled-components';
import { Checkbox, Typography } from 'antd';
import ContactCardFooterGlobal from './ContactCardFooterGlobal';
import ContactWidget from './ContactWidget';
import classNames from 'classnames';
import { IContactItem } from 'modules/Audience/interface';
import { openDetailProfile } from 'modules/GlobalActions';
import { getContactDashboard, getContactDetails } from 'modules/Campaigns/Audience/actions';

const { Paragraph } = Typography;

const ContactCardWrapper = styled.div<{ newContactAdded: boolean, index: number }>`
  &.activeCard {
    outline: 2px solid ${primaryColor}; 
    outline-offset: -2px;
    background: ${primaryActiveColor};
  }
  &:hover {
    cursor: pointer;
  }
  outline: ${(props) => (props.index === 0 && props.newContactAdded ? `2px solid ${primaryColor}` : 'none')}; 
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 13px;
  box-shadow: ${boxShadow};
  padding: 16px 19px;
  margin: 0px 6px;
  height: auto;
  min-height: 331px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    min-height: 261px;
  }
  .checkbox-div {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  .textual-area {
    text-align: center;
    width: 100%;
    .contact-name {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 24px;
      line-height: 28px;
      color: ${primaryHeadingColor};
      margin-bottom: 12px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 20px;
        line-height: 22px;
        margin-bottom: 3px;
      }
    }
    .contact-designation {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 16px;
      line-height: 20px;
      color: ${primaryHeadingColor};
      margin-bottom: 0px;
      &.gmail {
        color: ${primaryColor};
      }
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 13px;
        line-height: 15px
      }
    }
  }
  .contact-footer-wrapper {
    /* margin-top: 10px; */
    margin-top: auto;
  }
`;

type Props = {
  contact: IContactItem,
  handleSelectContacts: (contact: IContactItem) => void;
  selectedCount: number;
  index: number;
  selectDisable?: boolean;
  isSelected: boolean;
} & typeof defaultProps;

const defaultProps = {
  selectDisable: false,
};

const ContactCardGlobal = function ContactCardGlobal(props: Props) {
  const { contact, handleSelectContacts, selectedCount, index, selectDisable, isSelected } = props;
  const newContactAdded = useSelector((state: RootState) => state.globalContacts.newContactAdded);
  const { contactName, organization, designation, contactEmail } = contact;
  const [active, setActive] = useState(isSelected);

  const contactId = contact?.contactId?.toString();

  const userContactListItemClickHandler = () => {
    openDetailProfile();
    getContactDetails(contactId);
    getContactDashboard(contactId);
  };

  const handleClickCheckbox = () => {
    setActive(!active);
    handleSelectContacts(contact);
  }

  // To unselect all the selected contacts on clear selection.
  useEffect(() => {
    if (selectedCount === 0) {
      setActive(false);
    };
  }, [selectedCount])

  return (
    <ContactCardWrapper newContactAdded={newContactAdded} index={index} className={classNames('contact-card-global', { activeCard: active })} onClick={userContactListItemClickHandler}>
      <div className='checkbox-div'>
        <Checkbox checked={active} disabled={selectDisable} onChange={handleClickCheckbox} onClick={(e) => e.stopPropagation()} />
      </div>
      <ContactWidget contact={contact} diameter="115px" hidePersonality={contact.personality === 'N/A'} />
      <div className='textual-area'>
        <Paragraph className='contact-name text-truncate' ellipsis={{ rows: 1, tooltip: contactName }}>
          {contactName}
        </Paragraph>
        <Paragraph className='contact-designation text-truncate' ellipsis={{ rows: 1, tooltip: organization }}>
          {organization}
        </Paragraph>
        <Paragraph className='contact-designation text-truncate' ellipsis={{ rows: 1, tooltip: designation }}>
          {designation}
        </Paragraph>
        <Paragraph className='contact-designation gmail text-truncate' ellipsis={{ rows: 1, tooltip: contactEmail }}>
          {contactEmail}
        </Paragraph>
      </div>
      <ContactCardFooterGlobal contact={contact} />
    </ContactCardWrapper>
  );
};
ContactCardGlobal.defaultProps = defaultProps;
export default ContactCardGlobal;